import { createApp } from 'vue'
import ActivityCard from './ActivityCard'

const el = '.kb-component--activity-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ActivityCardDOM) => {
            const component = createApp(ActivityCard).use(Store)
            component.mount(ActivityCardDOM)
        })
    }
}
